<template>
  <div>
    <h3>{{ $t('Filter by Location') }}</h3>

    <div class="afdc-form-group">
      <div class="afdc-form-inline">
        <label class="afdc-col-form-label" for="afdc-analyze-country">{{ $t("Country") }}</label>
        <select v-model="queryCountry" id="afdc-analyze-country" class="afdc-form-control afdc-custom-select afdc-mx-sm-3">
          <option v-for="option in countryOptions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="afdc-form-group">
      <div class="afdc-custom-control afdc-custom-radio afdc-custom-control-inline">
        <input type="radio" v-model="queryLocationMode" value="region" id="afdc-analyze-location-mode-region" class="afdc-custom-control-input">
        <label class="afdc-custom-control-label" for="afdc-analyze-location-mode-region">{{ regionLabel }}</label>
      </div>
      <div class="afdc-custom-control afdc-custom-radio afdc-custom-control-inline">
        <input type="radio" v-model="queryLocationMode" value="address" id="afdc-analyze-location-mode-address" class="afdc-custom-control-input">
        <label class="afdc-custom-control-label" for="afdc-analyze-location-mode-address">{{ $t('Specific Address') }}</label>
      </div>
    </div>

    <div class="afdc-form-group" v-show="queryLocationMode === 'region'">
      <label class="afdc-sr-only" for="afdc-analyze-region">{{ regionLabel }}</label>
      <select class="afdc-form-control afdc-custom-select" v-model="queryRegion" id="afdc-analyze-region">
        <option value="all">{{ $t('All') }}</option>
        <optgroup v-for="countryOption in regionOptions" v-bind:key="countryOption.key" v-bind:label="countryOption.label">
          <option v-for="option in countryOption.regions" v-bind:key="option.key" v-bind:value="option.key">
            {{ option.name }}
          </option>
        </optgroup>
      </select>
    </div>

    <div v-show="queryLocationMode === 'address'">
      <div class="afdc-form-group">
        <label class="afdc-sr-only" for="afdc-analyze-location">{{ $t('Address or postal code') }}</label>
        <div class="afdc-input-group">
          <input type="text" v-model.lazy="queryLocation" class="afdc-form-control" id="afdc-analyze-location" value="" v-bind:placeholder="$t('Enter an address or postal code')">
          <div class="afdc-input-group-append">
            <button class="afdc-btn afdc-btn-secondary" type="submit" v-bind:aria-label="$t('Search')"><font-awesome-icon icon="search" class="afdc-fa-icon"/></button>
          </div>
        </div>
      </div>

      <div class="afdc-form-group">
        <div class="afdc-form-inline afdc-radius-input">
          <span>{{ $t("Limit results to within") }}</span>
          <input v-model.lazy="queryRadius" type="text" class="afdc-form-control" id="afdc-analyze-radius">
          <select v-model="queryRadiusUnit" class="afdc-custom-select">
            <option v-for="option in radiusUnitOptions" v-bind:key="option.key" v-bind:value="option.key">
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  computed: {
    countryOptions() {
      return this.$store.getters.loaderCountries;
    },

    regionLabel() {
      switch (this.$store.getters.getCountry) {
        case 'all':
          return this.$t('State/Province/Territory');
        case 'CA':
          return this.$t('Province/Territory');
        default:
          return this.$t('State/Territory');
      }
    },

    regionOptions() {
      const regions = this.$store.getters.loaderRegions;
      const optionsByCountry = {};
      for (let i = 0, len = regions.length; i < len; i += 1) {
        const region = regions[i];
        if (region.country_key) {
          if (!optionsByCountry[region.country_key]) {
            optionsByCountry[region.country_key] = [];
          }
          optionsByCountry[region.country_key].push(region);
        }
      }

      const options = [];
      const countries = this.$store.getters.loaderCountries;
      for (let i = 0, len = countries.length; i < len; i += 1) {
        const country = countries[i];
        if (optionsByCountry[country.key]) {
          options.push({
            key: country.key,
            label: country.name,
            regions: optionsByCountry[country.key],
          });
        }
      }

      return options;
    },

    radiusUnitOptions() {
      return this.$store.getters.loaderDistanceUnits;
    },

    queryCountry: syncInputRouteQuery('country'),
    queryLocationMode: syncInputRouteQuery('location_mode'),
    queryRegion: syncInputRouteQuery('region'),
    queryLocation: syncInputRouteQuery('location'),
    queryRadius: syncInputRouteQuery('radius'),
    queryRadiusUnit: syncInputRouteQuery('radius_unit'),
  },

  watch: {
    regionOptions: 'clearNonExistentRegion',
  },

  methods: {
    clearNonExistentRegion() {
      // See if the previously selected region is available in the region list
      // (this is triggered after toggling the country, which may update the
      // list of available regions).
      const { queryRegion } = this;
      if (queryRegion && queryRegion !== 'all') {
        let selectedRegionInOptions = false;
        for (let i = 0, len = this.regionOptions.length; i < len; i += 1) {
          const countryRegionOptions = this.regionOptions[i].regions;
          for (let j = 0, countryLen = countryRegionOptions.length; j < countryLen; j += 1) {
            const region = countryRegionOptions[j];
            if (region.key === queryRegion) {
              selectedRegionInOptions = true;
              break;
            }
          }

          if (selectedRegionInOptions) {
            break;
          }
        }

        if (!selectedRegionInOptions) {
          this.$router.replace({ query: { ...this.$route.query, region: undefined } });
        }
      }
    },
  },
};
</script>

<style lang="scss">
#analyze-radius {
  width: 55px;
  margin: 0 5px;
  text-align: center;
}

.radius-input {
  span {
    display: inline-block;
    vertical-align: middle;
  }
}

</style>
